export function bazaryab_admin_menu_controller($http, $scope, $mdDialog, $uibModal, MyConstant, $Menu) {
    "ngInject"

    $scope.getAllMenu = function () {
        $scope.AjaxLoading = true;

        $Menu.query((success) => {
            $scope.AjaxLoading = false;
            $scope.OrginalMenuList = angular.copy(success);
            $scope.MenuList = angular.copy(success);
            $scope.MenuList.unshift({ MenuTitle: 'نا مشخص', MenuID: 0, Level: 0 });
        }, (error) => {
            $scope.AjaxLoading = false;

        })
    };


    $scope.saveSorting = function () {
        $scope.tree.enabled = false;
        $scope.AjaxLoading = true;
        var menuList = angular.copy($scope.MenuList);
        menuList.splice(0, 1)
        $Menu.sort(menuList, (success) => {
            $scope.AjaxLoading = false;
            $scope.OrginalMenuList = angular.copy(success);
            $scope.MenuList = angular.copy(success);
            $scope.MenuList.unshift({ MenuTitle: 'نا مشخص', MenuID: 0, Level: 0 });
        }, (error) => {
            $scope.AjaxLoading = false;

        })


        // $http({
        //     method: 'POST',
        //     url: `${MyConstant.ApiUrl}StoreMenu/SortStoreMenuTreeList`,
        //     data: $scope.MenuList
        // }).then(function (success) {
        // }, function (error) {
        // })
    }

    $scope.cancelSorting = function () {
        $scope.tree.enabled = false;
        $scope.MenuList = angular.copy($scope.OrginalMenuList);
    }

    $scope.toggle = function (scope) {
        scope.toggle();
    };

    $scope.uploadSuccess = function (menu, $file, $message, $flow) {
        $scope.uploadProgrress = false;
        menu.ImageUrl = $message.replace(/['"]+/g, '');
    };

    $scope.uploadError = function ($file, $message, $flow) {
        $scope.uploadProgrress = false;
        $scope.uploadErrorMessage = $message.replace(/['"]+/g, '');
    };

    $scope.uploadImage = function ($flow, $file) {

        if ($flow.files[0].size > 100 * 1024) {
            $scope.uploadErrorMessage = "حجم عکس نباید بیشتر از 100KB باشد.";
        }
        else {
            $scope.uploadErrorMessage = null;
            $scope.uploadProgrress = true;
            $flow.upload();
        }
    };

    $scope.openMenu = function ($mdOpenMenu, $event) {
        var menu = $mdOpenMenu($event);
        $timeout(function () {
            var menuContent = document.getElementById('alerts-menu-content');

            function hasAnyAttribute(target, attrs) {
                if (!target) return false;
                for (var i = 0, attr; !!(attr = attrs[i]); ++i) {
                    var altForms = [attr, "data-" + attr, "x-" + attr];
                    for (var j = 0, rawAttr; !!(rawAttr = altForms[j]); ++j) {
                        if (target.hasAttribute(rawAttr)) {
                            return true;
                        }
                    }
                }
                return false;
            }

            function getClosest(el, tagName, onlyParent) {
                if (el instanceof angular.element) el = el[0];
                tagName = tagName.toUpperCase();
                if (onlyParent) el = el.parentNode;
                if (!el) return null;
                do {
                    if (el.nodeName === tagName) {
                        return el;
                    }
                } while (!!(el = el.parentNode));
                return null;
            }
            menuContent.parentElement.addEventListener('click', function (e) {
                var target = e.target;
                do {
                    if (target === menuContent) return;
                    if (hasAnyAttribute(target, ["ng-click", "ng-href", "ui-sref"]) || target.nodeName == "BUTTON" || target.nodeName == "MD-BUTTON") {
                        var closestMenu = getClosest(target, "MD-MENU");
                        if (!target.hasAttribute("disabled") && (!closestMenu || closestMenu == opts.parent[0])) {
                            if (target.hasAttribute("md-menu-disable-close")) {
                                event.stopPropagation();
                                angular.element(target).triggerHandler('click');
                            }
                            return; //let it propagate
                        }
                        break;
                    }
                } while (!!(target = target.parentNode));
            }, true);
        });
    };

    $scope.getAllMenu();

    $scope.addNewMenu = function () {
        // $scope.MenuList = angular.copy($scope.OrginalMenuList);
        $scope.SelectedCategory = null;
        $scope.SelectedProductType = null;
        $scope.EditMode = false;
        var menu = { ParentMenuID: 0, ParentName: 'نامشخص', ShowText: true, LinkType: 0, IsVisible: true }
        var parent = $scope.MenuList;
        $scope.menu = new $Menu(menu)
        $scope.selectNode = function (data) {
            $scope.menu.ParentName = data.MenuTitle;
            $scope.menu.ParentMenuID = data.MenuID;
            parent = data;
        };
        $scope.saveMenu = () => {
            var savedMenu = angular.copy($scope.menu)

            $scope.menu.$save((success) => {
                savedMenu.MenuID = success.MenuID;
                if (savedMenu.ParentMenuID === 0) {
                    parent.push(savedMenu)
                }
                else {
                    parent.SubStoreMenu = parent.SubStoreMenu || [];
                    parent.SubStoreMenu.push(savedMenu)
                }
                $scope.menu = null;
            }, (error) => {

            })
        }
    };

    $scope.selectMenu = function (menu) {
        $scope.SelectedCategory = null;
        $scope.SelectedProductType = null;
        $scope.menu = new $Menu(menu);
        $scope.EditMode = true;
        if (menu.LinkType === 1) {
            $scope.selectCategoryFromList(menu.CategoryID)
        }
        if (menu.LinkType === 2) {
            $scope.selectCategoryFromList(menu.CategoryID)
            $scope.selectProductTypeFromList(menu.CategoryID, menu.ProductTypeID)
        }

        $scope.saveMenu = function () {
            var savedMenu = angular.copy($scope.menu)
            $scope.menu.$save((success) => {
                angular.forEach(menu, (val, key) => {
                    menu[key] = savedMenu[key]

                })
                $scope.menu = null;

            }, (error) => {

            })
        };
        $scope.deleteMenu = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                template: `<div class="modal-header clearfix" data-ng-init="getCategoryOnlyVendor()">
                    <h3 style="text-align:center">حذف منو</h3>
                </div>
                <div class="modal-body clearfix" style="text-align:center">
                در صورت تایید این منو و تمام زیر منو های آن حذف می شود،آیا مایل به حذف هستید؟
                </div>
                <div class="modal-footer clearfix" style="text-align:center">
                <div class="form-group col-xs-12" >  
                    <button class="btn btn-warning" type="button" ng-click="delete()" >بله</button>
                    <button class="btn btn-warning" type="button" ng-click="closeAlert()">خیر</button>
                </div>
                
                </div>`,
                controller: function ($uibModalInstance, $scope) {
                    $scope.delete = function () {
                        $uibModalInstance.close('ok');

                    }; //end function delete

                    $scope.closeAlert = function () {
                        $uibModalInstance.dismiss('cancel');
                    }; // end closeAlert()
                },
                size: 'lg',
            });

            modalInstance.result.then(function () {



                $scope.menu.$remove((success) => {
                    menu.Deleted = true;
                    $scope.menu = null;
                }, (error) => {

                })
            });
        };
    };



    $scope.disabledSelect = function (data) {
        if ($scope.menu && data.MenuID == $scope.menu.MenuID) {
            return true;
        }
    };


    $scope.selectSortMenu = function (item, index) {
        $scope.SelectedSortMenu = item;
    };

    /**
     * mohasebe SortOrder-e- menu baraye sort kardane menu ha
     * @param  {[string]} position [first|last|before|after]
     * @param  {[int]} Plvl     [pervius menu SortOrder]
     * @param  {[int]} Nlvl     [Next menu SortOrder]
     * @return {[int]}          [SortOrder-e menuye jadid]
     */
    $scope.calCulateMenuSortOrder = function (position, Plvl, Nlvl) {
        if (position == 'first') { return (Plvl - 1); }
        if (position == 'last') { return (Nlvl + 1); }
        if (position == 'after' || position == 'before') {
            if (!Plvl) { return (Nlvl - 1); }
            if (!Nlvl) { return (Plvl + 1); }
            else { return (Nlvl + Plvl) / 2; }

        }
    };

    $scope.getAllCategory = function () {

        if (!$scope.AllCategoryList) {
            var query = {
                method: 'GET',
                url: `${MyConstant.ApiUrl}ECBCatregory/GetCategory`
            };
            $http(query).then(function (res) {
                $scope.AllCategoryList = res.data;
                $scope.$broadcast('AllCategoryList');
            });
        }
    };

    $scope.selectCategory = function (Category) {

        $scope.SelectedCategory = Category;
        $scope.SelectedProductType = null;
        $scope.menu.CategoryID = Category.CategoryID;
        $scope.menu.ProductTypeID = null;
        $scope.getProductType(Category.CategoryID);
    };

    $scope.getProductType = function (CatID) {
        var query = {
            method: 'GET',
            url: `${MyConstant.ApiUrl}ECBProductType/GetProductType/?categoryID=${CatID}`
        };
        $http(query).then(function (res) {
            $scope.ProductTypeList = res.data;
            $scope.$broadcast('ProductTypeList');

        });
    };

    $scope.selectProductType = function (ProductType) {
        $scope.SelectedProductType = ProductType;
        $scope.menu.ProductTypeID = ProductType.ProductTypeID;
    };



    $scope.close = () => { $scope.menu = null; }

    $scope.selectCategoryFromList = function (CatID) {
        $scope.getAllCategory();
        if ($scope.AllCategoryList) {
            angular.forEach($scope.AllCategoryList, function (key, value) {
                if (key.CategoryID == CatID) {
                    $scope.SelectedCategory = key;
                }
            });
        }
        else {

            $scope.$on('AllCategoryList', function () {
                angular.forEach($scope.AllCategoryList, function (key, value) {
                    if (key.CategoryID == CatID) {
                        $scope.SelectedCategory = key;
                    }
                });
            });
        }
    };

    $scope.selectProductTypeFromList = function (CatID, ProductTypeID) {
        $scope.getProductType(CatID);
        if ($scope.ProductTypeList) {
            angular.forEach($scope.ProductTypeList, function (key, value) {
                if (key.ProductTypeID == ProductTypeID) {
                    $scope.SelectedProductType = key;
                }
            });
        }
        else {
            $scope.$on('ProductTypeList', function () {
                angular.forEach($scope.ProductTypeList, function (key, value) {
                    if (key.ProductTypeID == ProductTypeID) {
                        $scope.SelectedProductType = key;
                    }
                });
            });
        }
    };



    $scope.menuGenerator = function () {
        $mdDialog.show({
            controller: function ($scope, $mdDialog, $MenuGenertor, $mdToast, $document) {
                "ngInject"
                $MenuGenertor.getAllMenu().then(function (res) {
                    $scope.MenuList = angular.copy(res.data);
                    $scope.MenuList.unshift({ MenuTitle: 'نا مشخص', MenuID: 0, Level: 0 });
                });

                $MenuGenertor.getAllCategory().then(function (res) {
                    $scope.AllCategoryList = res.data;
                });

                $scope.selectCategory = function (data) {
                    $scope.generator = $scope.generator || {};
                    $scope.generator.rootID = data.ID;
                    $scope.generator.rootType = data.Type == 'Category' ? 1 : 2;
                };

                $scope.selectParentMenu = function (data) {
                    $scope.generator = $scope.generator || {};
                    $scope.generator.parentMenuID = data.MenuID;
                    $scope.generator.parentMenuTitle = data.MenuTitle;
                    $scope.generator.parentLevel = data.Level;
                };

                $scope.generetMenu = function () {
                    $scope.buldingStructure = true;
                    $MenuGenertor.getStructure($scope.generator).then(function (res) {
                        $scope.buldingStructure = false;
                        var menuStructureList = [];
                        var ParentMenu;
                        menuStructureList.push(res.data);
                        if ($scope.generator.parentMenuID !== 0) {
                            ParentMenu = { 'MenuTitle': $scope.generator.parentMenuTitle, 'SubStoreMenu': menuStructureList };
                        }
                        else {
                            ParentMenu = res.data;
                        }

                        $scope.menuStructure = [];
                        $scope.menuStructure.push(ParentMenu);
                    });
                };
                $scope.menuStructureSelect = function (data) {

                };
                $scope.removeNode = function (node, parent, index) {

                };
                $scope.buildMenu = function () {
                    $scope.AjaxLoading = true;
                    $scope.MenuList = null;
                    if ($scope.generator.parentMenuID !== 0) {
                        $MenuGenertor.buildMenu($scope.menuStructure[0].SubStoreMenu[0]).then(function (res) {
                            if (res.data) {
                                $mdToast.show($mdToast.simple().position('top right').textContent('تغییرات با موفقیت ذخیره شد.').hideDelay(3000).parent($document.find('.md-dialog-container')));
                            }
                            else {
                                $mdToast.show($mdToast.simple().position('top right').textContent('خطایی رخ داده است لطفا مجددا تلاش کنید').hideDelay(5000).parent($document.find('.md-dialog-container')));
                            }
                            $scope.AjaxLoading = false;
                            $MenuGenertor.getAllMenu().then(function (res) {
                                $scope.MenuList = angular.copy(res.data);
                                $scope.MenuList.unshift({ MenuTitle: 'نا مشخص', MenuID: 0, Level: 0 });
                            });
                        });


                    }
                    else {
                        $MenuGenertor.buildMenu($scope.menuStructure[0]).then(function (res) {
                            if (res.data) {
                                $mdToast.show($mdToast.simple().position('top right').textContent('تغییرات با موفقیت ذخیره شد.').hideDelay(3000).parent($document.find('.md-dialog-container')));
                            }
                            else {
                                $mdToast.show($mdToast.simple().position('top right').textContent('خطایی رخ داده است لطفا مجددا تلاش کنید').hideDelay(5000).parent($document.find('.md-dialog-container')));
                            }
                            $scope.AjaxLoading = false;
                            $MenuGenertor.getAllMenu().then(function (res) {
                                $scope.MenuList = angular.copy(res.data);
                                $scope.MenuList.unshift({ MenuTitle: 'نا مشخص', MenuID: 0, Level: 0 });
                            });

                        });

                    }
                };
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

            },
            preserveScope: true,
            template: `<md-dialog class="MenuGenerator full-screen" aria-label="منوساز" ng-cloak>
                <div layout="row" ng-show="AjaxLoading" layout-align="center center" class="AjaxLoading">
                    <md-progress-circular class="default" md-diameter="40"></md-progress-circular>
                </div>
                <form name="AddProduct" novalidate>
                    <md-toolbar>
                        <div class="md-toolbar-tools">

                            <h2 ng-class="">ساخت انبوه منو</h2>
                            <span flex></span>
                            <md-button class="md-icon-button" ng-click="cancel()">
                                <md-icon class="fa fa-times" aria-label="Close dialog"></md-icon>
                            </md-button>
                        </div>
                    </md-toolbar>

                    <md-dialog-content>
                        <div class="generetSteps">
                            <md-card>
                                <md-card-content>
                                    <h2>انتخاب منو والد</h2>
                                    <div layout="row" ng-show="!MenuList" layout-align="center center" class="">
                                        <md-progress-circular class="default" md-diameter="40"></md-progress-circular>
                                    </div>
                                    <div  data-angular-treeview="false" data-tree-model="MenuList" data-tree-id="MenuID" data-node-id="MenuID" data-node-label="MenuTitle"
                                    data-node-children="SubStoreMenu" data-node-function="selectParentMenu">
                                    </div>
                                </md-card-content>
                            </md-card>
                            <md-card>
                            <md-card-content>
                                    <h2>انتخاب دسته بندی</h2>
                                    <div layout="row" ng-show="!AllCategoryList" layout-align="center center" class="">
                                        <md-progress-circular class="default" md-diameter="40"></md-progress-circular>
                                    </div>
                                    <div  data-angular-treeview="false" data-tree-model="AllCategoryList" data-tree-id="ID" data-node-id="ID" data-node-label="Name" data-node-children="SubCategories" data-node-function="selectCategory">
                                    </div>
                                </md-card-content>
                            </md-card>
                            <md-card>
                                <md-card-content>
                                    <h2>انتخاب عمق دسته بندی</h2>
                                    <div>
                                        <md-select ng-model="generator.deepType" placeholder="عمق" class="md-no-underline">
                                            <md-option value="1">دسته‌بندی</md-option>
                                            <md-option value="2">گروه‌کالایی</md-option>
                                            <md-option value="3">سازنده</md-option>
                                        </md-select>
                                        <div class="deapConfig">
                                            <span class="title">
                                                تنظیمات سطح اول
                                            </span>
                                            <ul>
                                                <li><md-checkbox name="name" ng-model="generator.Level1_ShowText" aria-label="label" ng-init="generator.Level1_ShowText = true">نمایش متن</md-checkbox></li>
                                                <li><md-checkbox name="name" ng-model="generator.Level1_ShowIcon" aria-label="label">نمایش آیکون</md-checkbox></li>
                                            </ul>
                                        </div>
                                        <md-divider ></md-divider>
                                        <div class="deapConfig">
                                            <span class="title">
                                                تنظیمات سطح دوم                     
                                            </span>
                                            <ul>
                                                <li><md-checkbox name="name" ng-model="generator.Level2_ShowText" aria-label="label" ng-init="generator.Level2_ShowText = true">نمایش متن</md-checkbox></li>
                                                <li><md-checkbox name="name" ng-model="generator.Level2_ShowIcon" aria-label="label">نمایش آیکون</md-checkbox></li>
                                            </ul>
                                        </div>
                                        <md-divider ></md-divider>
                                        <div class="deapConfig">
                                            <span class="title">
                                                تنظیمات سطح سوم
                                            </span>
                                            <ul>
                                                <li><md-checkbox name="name" ng-model="generator.Level3_ShowText" aria-label="label" ng-init="generator.Level3_ShowText = true">نمایش متن</md-checkbox></li>
                                                <li><md-checkbox name="name" ng-model="generator.Level3_ShowIcon" aria-label="label">نمایش آیکون</md-checkbox></li>
                                            </ul>
                                        </div>
                                    </div>
                                </md-card-content>
                            </md-card>
                            <div class="PreViewbtn">
                                <md-button class="md-raised" ng-disabled="!generator.deepType || (!generator.parentMenuID && generator.parentMenuID != 0) || !generator.rootID" ng-click="generetMenu()" aria-label="پیش نمایش"> پیش نمایش </md-button>
                            </div>

                            <md-card class="PreViewBox">
                                <md-card-content>
                                    <h2>پیش نمایش</h2>
                                    <div layout="row" ng-show="buldingStructure" layout-align="center center" class="">
                                        <md-progress-circular class="default" md-diameter="40"></md-progress-circular>
                                    </div>
                                    <div ng-hide="buldingStructure" treeModel data-editable-node="true" data-angular-treeview="false" data-tree-model="menuStructure" data-tree-id="MenuID" data-node-id="MenuID" data-node-label="MenuTitle"
                                        data-node-children="SubStoreMenu" data-node-function="menuStructureSelect()">
                                    </div>
                                    <div ng-hide="buldingStructure" ng-if="!menuStructure">
                                        محتوایی جهت نمایش نیست
                                    </div>
                                </md-card-content>
                            </md-card>
                            
                        </div>
                        <div class="center">
                            <md-button class="md-raised" ng-disabled="!menuStructure" ng-click="buildMenu()" aria-label="ساخت منو"> ساخت منو </md-button>
                        </div>
                    </md-dialog-content>

                    <md-dialog-actions style="bottom: 0;position: fixed;width: 100%;">
                        <md-button class="md-raised" ng-click="cancel(Product)">
                            <span ng-class="Label.ChangeWage.Cancel.Class">
                    خروج
                    </span>
                        </md-button>
                    </md-dialog-actions>
                </form>
            </md-dialog>`,
            parent: angular.element(document.body),
            targetEvent: Element,
            clickOutsideToClose: true,
        })
            .then(function () {

            }, function () {
                $scope.getAllMenu();
            });
    };

}


// WEBPACK FOOTER //
// ./src/components/bazaryab-admin-menu/bazaryab-admin-menu.controller.ts